/**
 * Dedicated create routes like `/cspm/receipts/new` do not define `:id`,
 * so `useParams().id` is undefined — not the string `"new"`.
 */
export function isCspmCreateRoute(
  routeId: string | undefined,
  pathname: string
): boolean {
  if (!routeId || routeId === 'new') return true;
  return /\/new\/?$/.test(pathname);
}
